/** @velyn-custom BEGIN — vely-testimonials.js (press logos + quote + pill pagination) */
(function () {
  const getSwiper = () => window.Swiper;

  class VelyTestimonials extends HTMLElement {
    connectedCallback() {
      if (this._velyTestimonialsInitStarted) return;
      this._velyTestimonialsInitStarted = true;
      this.waitForSwiper(() => this.init());
    }

    disconnectedCallback() {
      if (this._thumbsSwiper) {
        this._thumbsSwiper.destroy(true, true);
        this._thumbsSwiper = null;
      }
      if (this._mainSwiper) {
        this._mainSwiper.destroy(true, true);
        this._mainSwiper = null;
      }
      this._velyTestimonialsInitStarted = false;
      this.classList.remove("vely-testimonials--ready");
    }

    waitForSwiper(callback, attempt = 0) {
      if (typeof getSwiper() === "function") {
        callback();
        return;
      }
      if (attempt > 80) {
        console.warn("[vely-testimonials] window.Swiper is not available");
        return;
      }
      setTimeout(() => this.waitForSwiper(callback, attempt + 1), 50);
    }

    init() {
      const SwiperCtor = getSwiper();
      if (typeof SwiperCtor !== "function") return;

      const mainEl = this.querySelector(".vely-testimonials__main");
      if (!mainEl) return;

      const thumbsEl = this.querySelector(".vely-testimonials__thumbs");
      const hasThumbs = Boolean(thumbsEl);
      const autoplayOn = mainEl.dataset.autoplay === "true";
      const speed = Number(mainEl.dataset.speed) || 300;
      let autoplay = false;
      if (autoplayOn) {
        autoplay = {
          delay: Number(mainEl.dataset.autoPlaySpeed) || 5000,
          pauseOnMouseEnter: true,
        };
      }

      const itemDesktop = Number(thumbsEl?.dataset.desktop) || 4;
      const itemTablet = Number(thumbsEl?.dataset.tablet) || itemDesktop;
      const thumbGap = Number(thumbsEl?.dataset.gap) || 60;
      const mobileThumbGap = 32;
      const useLoop = this.dataset.loop !== "false";

      if (hasThumbs) {
        this._thumbsSwiper = new SwiperCtor(thumbsEl, {
          slidesPerView: "auto",
          spaceBetween: mobileThumbGap,
          watchSlidesProgress: true,
          loop: useLoop,
          allowTouchMove: true,
          slideToClickedSlide: true,
          slideActiveClass: "swiper-slide-thumb-active",
          breakpoints: {
            768: { slidesPerView: itemTablet, spaceBetween: thumbGap },
            1025: { slidesPerView: itemDesktop, spaceBetween: thumbGap },
          },
        });
      }

      const pagination =
        window.VelySwiperPagination?.getConfig(this) || false;

      this._mainSwiper = new SwiperCtor(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed,
        loop: useLoop,
        autoplay,
        autoHeight: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        thumbs: hasThumbs ? { swiper: this._thumbsSwiper } : undefined,
        pagination,
        on: {
          init(swiper) {
            swiper.updateAutoHeight(0);
            window.VelySwiperPagination?.pinInFlow(swiper.pagination?.el);
            window.VelySwiperPagination?.setActiveBullet(swiper);
          },
          slideChange(swiper) {
            window.VelySwiperPagination?.setActiveBullet(swiper);
          },
          slideChangeTransitionEnd(swiper) {
            swiper.updateAutoHeight(0);
            window.VelySwiperPagination?.setActiveBullet(swiper);
          },
        },
      });

      window.VelySwiperPagination?.pinInFlow(this._mainSwiper?.pagination?.el);
      window.VelySwiperPagination?.setActiveBullet(this._mainSwiper);

      if (hasThumbs && this._thumbsSwiper) {
        this._thumbsSwiper.on("click", (sw) => {
          const clicked = sw.clickedSlide;
          if (!clicked) return;
          const idx = parseInt(
            clicked.getAttribute("data-swiper-slide-index") ??
              String(sw.clickedIndex),
            10
          );
          if (Number.isNaN(idx) || idx < 0) return;
          if (useLoop) {
            this._mainSwiper.slideToLoop(idx);
          } else {
            this._mainSwiper.slideTo(idx);
          }
        });
      }

      this.classList.add("vely-testimonials--ready");
    }
  }

  if (!customElements.get("vely-testimonials")) {
    customElements.define("vely-testimonials", VelyTestimonials);
  }
})();
/** @velyn-custom END — vely-testimonials.js */
